import { createContext, useContext, type ReactNode } from "react";

// Conversation-scoped values that deep descendants need (e.g. artifact
// renderers inside markdown) but don't want to receive via prop drilling.
interface ConversationContextValue {
  conversationId: string;
}

const ConversationContext = createContext<ConversationContextValue | null>(null);

export const ConversationProvider = ({
  conversationId,
  children,
}: {
  conversationId: string;
  children: ReactNode;
}) => (
  <ConversationContext.Provider value={{ conversationId }}>{children}</ConversationContext.Provider>
);

export const useConversationContext = (): ConversationContextValue => {
  const ctx = useContext(ConversationContext);
  if (!ctx) {
    throw new Error("useConversationContext must be used within <ConversationProvider>");
  }
  return ctx;
};

export const useConversationId = (): string => useConversationContext().conversationId;
